import {
  Required,
  IsString,
  DataValidator,
  transformKeys,
  IsNumber,
  IsArray,
} from "@/utils/type-vaildator";
import api from "./api";

// 原始接口
export interface GetAgentUserMaterialFoldersResponse {
  list: AgentUserMaterialFolder[];
  page: number;
  page_size: number;
  total: number;
  total_pages: number;
};

export interface AgentUserMaterialFolder {
  agent_id: number;
  create_time: number;
  folder_id: number;
  folder_name: string;
  id: number;
  item_count: number;
  type: number;
  update_time: number;
  user_id: number;
};


// 请求接口
interface GetAgentUserMaterialFoldersRequest {
  agentId: string,
  userId: string,
  type: number,
  page: number,
  pageSize: number
}

export class AgentUserMaterialFolderData {
  @Required("Id cannot be empty")
  @IsNumber("Id must be a number")
  id: number;

  @Required("Folder name cannot be empty")
  @IsString("Folder name must be a string")
  folderName: string;

  @Required("Item count cannot be empty")
  @IsNumber("Item count must be a number")
  itemCount: number;

  @Required("Folder id cannot be empty")
  @IsNumber("Folder id must be a number")
  folderId: number;
}

export class GetAgentUserMaterialFoldersData {
  // @Required("List cannot be empty")
  @IsArray("List must be an array")
  list: AgentUserMaterialFolderData[];

  @Required("Page cannot be empty")
  @IsNumber("Page must be a number")
  page: number;

  @Required("Page size cannot be empty")
  @IsNumber("Page size must be a number")
  pageSize: number;
  
  @Required("Total cannot be empty")
  @IsNumber("Total must be a number")
  total: number;

  @Required("Total pages cannot be empty")
  @IsNumber("Total pages must be a number")
  totalPages: number;
}

const transformAndValidateAgent = (
  response: GetAgentUserMaterialFoldersResponse
): GetAgentUserMaterialFoldersData => {
  const transformedData = transformKeys(response);

  try {
    return DataValidator.validateOrThrow(transformedData, GetAgentUserMaterialFoldersData);
  } catch (error) {
    console.error("Agent user material folders data validation failed:", error.message);
    throw error;
  }
};

/** agent用户素材库素材列表 */
export const getAgentUserMaterialFolders = async ({
  agentId,
  userId,
  type,
  page,
  pageSize,
}: GetAgentUserMaterialFoldersRequest): Promise<GetAgentUserMaterialFoldersData> => {
  const response = await api.post<GetAgentUserMaterialFoldersResponse>('/user_material/get_agent_user_material_folders', {
    agent_id: agentId,
    user_id: userId,
    type: type,
    page,
    page_size: pageSize,
  });
  const data = transformAndValidateAgent(response.data);
  return data;
};
